import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { RectangleButton } from 'components/Button/RectangleButton';
import {
  BrandingContainer,
  HorizontalLine,
  LeftAndRightTabContainer,
  LeftTabContainer,
  LeftTabHeading,
  ContestLogoHeading,
  EditorLogoContainer,
  UploadAndRemoveButtonContainer,
  HiddenFileInput,
  ImageContainer,
  LogoImage,
  RenderTabContainer,
} from '../styles';

export default React.memo(({ updateContestDetails }) => {
  let { contest } = useSelector((state) => state.CMSEditContestReducer);

  const [subTab, setSubTab] = useState('contestLogo');
  const [contestLogo, setContestLogo] = useState(contest?.contestLogo ?? '');
  const [landingPageLogo, setLandingPageLogo] = useState(contest?.landingPageLogo ?? '');
  const [contestBackground, setContestBackground] = useState(contest?.contestBackground ?? '');

  const contestLogoInputRef = useRef(null);
  const landingLogoInputRef = useRef(null);
  const backgroundInputRef = useRef(null);

  const handleImage = (file) => {
    let extension = file.name.substr(file.name.lastIndexOf('.') + 1);
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      if (subTab === 'contestLogo') {
        reader.onload = () => {
          setContestLogo(reader.result);
          updateContestDetails({ contestLogo: reader.result });
        };
      } else if (subTab === 'landingPageLogo') {
        reader.onload = () => {
          setLandingPageLogo(reader.result);
          updateContestDetails({ landingPageLogo: reader.result });
        };
      } else {
        reader.onload = () => {
          setContestBackground(reader.result);
          updateContestDetails({ contestBackground: reader.result });
        };
      }
    } else {
      toast.error('Please select an image');
    }
  };

  const renderTabs = () => {
    if (subTab === 'contestLogo') {
      return (
        <EditorLogoContainer>
          <UploadAndRemoveButtonContainer>
            <RectangleButton onClick={() => contestLogoInputRef.current.click()}>Choose Logo</RectangleButton>
            <HiddenFileInput ref={contestLogoInputRef} onChange={(e) => handleImage(e.target.files[0])} />
            {contestLogo && (
              <RectangleButton
                onClick={() => {
                  setContestLogo('');
                  updateContestDetails({ contestLogo: '' });
                }}
              >
                Remove
              </RectangleButton>
            )}
          </UploadAndRemoveButtonContainer>
          <ImageContainer>{contestLogo && <LogoImage src={contestLogo} alt="upload" />}</ImageContainer>
        </EditorLogoContainer>
      );
    } else if (subTab === 'landingPageLogo') {
      return (
        <EditorLogoContainer>
          <UploadAndRemoveButtonContainer>
            <RectangleButton onClick={() => landingLogoInputRef.current.click()}>Choose Logo</RectangleButton>
            <HiddenFileInput ref={landingLogoInputRef} onChange={(e) => handleImage(e.target.files[0])} />
            {landingPageLogo && (
              <RectangleButton
                onClick={() => {
                  setLandingPageLogo('');
                  updateContestDetails({ landingPageLogo: '' });
                }}
              >
                Remove
              </RectangleButton>
            )}
          </UploadAndRemoveButtonContainer>
          <ImageContainer>{landingPageLogo && <LogoImage src={landingPageLogo} alt="upload" />}</ImageContainer>
        </EditorLogoContainer>
      );
    } else {
      return (
        <EditorLogoContainer>
          <UploadAndRemoveButtonContainer>
            <RectangleButton onClick={() => backgroundInputRef.current.click()}>Choose Background</RectangleButton>
            <HiddenFileInput ref={backgroundInputRef} onChange={(e) => handleImage(e.target.files[0])} />
          </UploadAndRemoveButtonContainer>
          <ImageContainer>
            {contestBackground && <LogoImage isBackgroundImage src={contestBackground} alt="upload" />}
          </ImageContainer>
        </EditorLogoContainer>
      );
    }
  };

  return (
    <BrandingContainer>
      <ContestLogoHeading>Contest logo and contestBackground</ContestLogoHeading>
      <HorizontalLine />
      <LeftAndRightTabContainer>
        <LeftTabContainer>
          <LeftTabHeading isActive={subTab === 'contestLogo'} onClick={() => setSubTab('contestLogo')}>
            Editor Logo
          </LeftTabHeading>
          <LeftTabHeading isActive={subTab === 'landingPageLogo'} onClick={() => setSubTab('landingPageLogo')}>
            Landing Page Logo
          </LeftTabHeading>
          <LeftTabHeading isActive={subTab === 'contestBackground'} onClick={() => setSubTab('contestBackground')}>
            Background
          </LeftTabHeading>
        </LeftTabContainer>
        <RenderTabContainer>{renderTabs()}</RenderTabContainer>
      </LeftAndRightTabContainer>
    </BrandingContainer>
  );
});
